/*global document*/

import React, { Component } from "react"
import PropTypes from "prop-types"
import SbEditable from "storyblok-react"
import fetch from "cross-fetch"
import _ from "lodash"
import queryString from "query-string"

import EfSetTest from "./efSetTest"

function isContactFound(contact) {
  let isFound = false
  for (const key in contact) {
    if (Object.hasOwnProperty.call(contact, key) && contact[key] != null) {
      isFound = true
      break
    }
  }

  return isFound
}

class EfSet extends Component {
  state = {
    loaded: false,
    invalid: false,
    contact: null,
  }

  getContactData(contactId) {
    return fetch(
      `${process.env.GATSBY_SALESFORCE_API}/hulthousing/services/apexrest/GetContactInfo`,
      {
        method: "POST",
        body: JSON.stringify({ contactID: contactId }),
      }
    )
      .then((resp) => resp.json())
      .then((data) => JSON.parse(data))
  }

  componentDidMount() {
    if (typeof window !== "undefined") {
      const queryParams = queryString.parse(window.location.search)
      const contactId = queryParams.S
      if (contactId && contactId.startsWith("006")) {
        let isValid = false
        this.getContactData(contactId).then((contact) => {
          if (isContactFound(contact)) {
            contact.ID = contactId
            if (contact.Birthdate) {
              contact.Birthday_year = new Date(contact.Birthdate)
                .getFullYear()
                .toString()
            }
            this.setState({
              loaded: true,
              contact,
            })
          } else {
            this.setState({
              loaded: true,
              invalid: true,
            })
          }
        })
      } else {
        this.setState({
          loaded: true,
          invalid: true,
        })
      }
    }
  }

  getFSWrapperClass = () => {
    const { loaded } = this.state

    if (!loaded) {
      return " fs-wrapper--loading"
    }
    return ""
  }

  render = () => {
    const { blok } = this.props
    const { efset_test } = blok
    const { loaded, contact, invalid } = this.state

    if (efset_test)
      return (
        <SbEditable content={blok}>
          <div className={`fs-wrapper${this.getFSWrapperClass()}`}>
            {(loaded && contact && (
              <EfSetTest
                user_id={contact.ID}
                integration_id={efset_test.content.integration_id}
                // email={contact.Email}
                country_code={contact.CountryCode || ""}
                gender={contact.Gender || ""}
                bd_year={contact.Birthday_year || ""}
                given_name={contact.FirstName || ""}
                family_name={contact.LastName || ""}
              />
            )) ||
              (loaded && invalid && (
                <p>The Application ID is not valid. Please try again.</p>
              ))}
          </div>
        </SbEditable>
      )

    return (
      <SbEditable content={blok}>
        <p>Missing EF SET CONFIG</p>
      </SbEditable>
    )
  }
}

EfSet.propTypes = {
  blok: PropTypes.shape({
    efset_test: PropTypes.object.isRequired,
  }).isRequired,
}

export default EfSet
